export const SET_FORM_PHONE_NUMBER_REQUEST = 'SET_FORM_PHONE_NUMBER_REQUEST';
export const SET_FORM_REGISTER_REQUEST = 'SET_FORM_REGISTER_REQUEST';
export const SET_FORM_PIN_NUMBER_REQUEST = 'SET_FORM_PIN_NUMBER_REQUEST';

export const VALID_INPUT_PHONE = 'VALID_INPUT_PHONE';
export const VALID_INPUT_PIN = 'VALID_INPUT_PIN';

export const GET_PIN_FOR_AUTHORIZE = 'GET_PIN_FOR_AUTHORIZE';
export const GET_PIN_FOR_AUTHORIZE_LOADED = 'GET_PIN_FOR_AUTHORIZE_LOADED';
export const GET_PIN_FOR_AUTHORIZE_ERROR = 'GET_PIN_FOR_AUTHORIZE_FAILED';

export const REGISTER_PHONE = 'REGISTER_PHONE';
export const REGISTER_PHONE_LOADED = 'REGISTER_PHONE_LOADED';
export const REGISTER_PHONE_ERROR = 'REGISTER_PHONE_FAILED';

export const GET_CODE_OF_AUTHORIZE = 'GET_CODE_OF_AUTHORIZE';
export const GET_CODE_OF_AUTHORIZE_LOADED = 'GET_CODE_OF_AUTHORIZE_LOADED';
export const GET_CODE_OF_AUTHORIZE_ERROR = 'GET_PIN_FOR_AUTHORIZE_FAILED';

export const GO_TO_URL_TO_SUBSCRIPTION = 'GO_TO_URL_TO_SUBSCRIPTION';

export const EDIT_PHONE_NUMBER = 'EDIT_PHONE_NUMBER';

export const COUNTRY_CODE = '55';

export const SHOW_MESSAGE_WITHOUT_SUBSCRIPTION = 'SHOW_MESSAGE_WITHOUT_SUBSCRIPTION';

export const BOOTSTRAP_DATA = 'BOOTSTRAP_DATA';

export const LOADING_ON = 'LOADING_ON';
export const LOADING_OFF = 'LOADING_OFF';
export const SUBSCRIPTION_PLAN = 'SUBSCRIPTION_PLAN';

/* ===========================================================
 =            Constants for Error Message Handler            =
 ===========================================================*/
export const MSG_PHONE_NUMBER_EMPTY = 'Ingrese un número para avanzar';
// eslint-disable-next-line
export const MSG_PHONE_NUMBER_INCONPLETE = 'Número de celular inválido.';
export const MSG_PHONE_NUMBER_INVALID_TO_SEND_PIN = 'Número de celular inválido para enviar un PIN.';
export const MSG_PIN_NUMBER_EMPTY = 'Digite un PIN para avanzar';
export const MSG_PIN_INVALID = 'El PIN ingresado es inválido.';
export const MSG_PIN_INCOMPLETE = 'El PIN debe tener 4 números.';
export const MSG_REGISTER_ERROR = 'Error al registrar número.';
export const MSG_REGISTER_TIMEOUT = 'Tiempo de espera para registro finalizado, por favor, presiona volver y vuelve a reintentar el flujo.';
export const MSG_PIN_ERROR = 'Ocurrió un error.';
export const MSG_RECAPTCHA_DATA_EMPTY = 'Validación de Recaptcha falló.';

/* =====  End of Constants for Error Message Handler  ======*/
